export class FailedChallengesApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'FailedChallengesApiError';
  }
}
